import type { ApiAvailableAction, ApiAvailableActionsForShipment } from './transportExecution.availableActions.schema';
import type {
    AvailableAction,
    AvailableActionsForShipment,
} from '../../domain/model/available-actions/AvailableActions.types';

const toAvailableAction = (src: ApiAvailableAction): AvailableAction => ({
    role: src.role,
    duns: src.duns,
    transferType: src.transfer_type,
    transportLegId: src.transport_leg_id,
});

export const toAvailableActionsForShipment = (src: ApiAvailableActionsForShipment): AvailableActionsForShipment => ({
    shipmentId: src.shipment_id,
    availableActions: src.available_actions.map(toAvailableAction),
});
